export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fmt = (n) =>
    Number(n).toLocaleString("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });

export const pct = (p) => Math.round((1 - p.our_price / p.hd_price) * 100);

export const savings = (p) => Math.round(p.hd_price - p.our_price);

export const scrollToId = (id) => {
    if (id === "top") {
        if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
        else window.scrollTo({ top: 0, behavior: "smooth" });
        return;
    }
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
    else el.scrollIntoView({ behavior: "smooth" });
};

export const STORE = {
    name: "Karagna.com",
    city: "Clifton, New Jersey",
    addressLine1: "851 Van Houten Ave",
    addressLine2: "Clifton, NJ 07013",
    phoneDisplay: "(646) 934-3271",
    phoneHref: "tel:+16469343271",
    mapsUrl: "https://www.google.com/maps/search/?api=1&query=851+Van+Houten+Ave+Clifton+NJ",
    hours: [
        { label: "Mon – Fri", days: [1, 2, 3, 4, 5], open: 9, close: 19 },
        { label: "Saturday", days: [6], open: 9, close: 18 },
        { label: "Sunday", days: [0], open: 10, close: 16 },
    ],
};

export const isStoreOpen = () => {
    const now = new Date();
    const parts = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        weekday: "short",
        hour: "numeric",
        hour12: false,
    }).formatToParts(now);
    const weekday = parts.find((p) => p.type === "weekday").value;
    const hour = parseInt(parts.find((p) => p.type === "hour").value, 10);
    const dayIdx = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[weekday];
    for (const h of STORE.hours) {
        if (h.days.includes(dayIdx) && hour >= h.open && hour < h.close) return true;
    }
    return false;
};
